import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const alignToApplianceBottomMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Align To Bottom',
		isVisible: ({ context, controller }): boolean => {
			// don't display if there are no selections
			// if (controller.readonly || ui.selected.length === 0) return false;

			// filter to selections the are bound to counter or bound to bottom
			// const selectionsAreNotBoundToCounterOrBottom = ui.selected.filter((ref) => {
			// 	const locator = controller?.kitchen?.getReferenceMap(ref) ?? null;

			// 	if (locator && locator.type === BlueprintInstanceType.PanelItem) {
			// 		const { item } = locator.panelItem;
			// 		return item.distanceAboveCountertop === 0 && item.distanceBelowCountertop === null;
			// 	}

			return false
			// });

			// only show when multiple items are selected
			// return selectionsAreNotBoundToCounterOrBottom.length === ui.selected.length;
		},
		onClick: ({ refMap, controller }): void => {
			// appState.ui.selected.forEach((ref) => {
			// 	const refMap = controller?.kitchen?.getReferenceMap(ref);
			// 	refMap?.panelItem?.alignToBottom();
			// });
		}
	};
};
